// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import FamilyGroupAllocationToCapacity from './family-group-allocation-to-capacity';
import React from 'react';

function FamilyGroupAllocationToCapacityPage () {

    return (
        <AuthenticatedPage className="atp-page atp-family-group-allocation-to-capacity-page">
            <FamilyGroupAllocationToCapacity />
        </AuthenticatedPage>
    );

}
FamilyGroupAllocationToCapacityPage.displayNAme = 'FamilyGroupAllocationToCapacityPage';

export default FamilyGroupAllocationToCapacityPage;
